// ----------------------------------------------------------------------------
// Snippet: Smart Cart Template
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_smart-cart-template.scss';

//Adds "Last Chance Disclaimer" to products in SmartCart with Tags "last-chance" and "exchange-only".
function addLastChanceDisclaimer() {      
    $('.rebuy__cart__line-item').each(function(index, value) {
        var itemDisclaimer = $(this).find('.rebuy-cart__last-chance_disclaimer');
        itemDisclaimer.html('');
        itemDisclaimer.addClass('hidden');
        
        if ($(this).attr('data-tags').includes("finalsale")) {
            itemDisclaimer.html("<span> This item is final sale</span>"); 
            itemDisclaimer.removeClass('hidden');
        } else if ($(this).attr('data-tags').includes("exchange-only") || $(this).attr('data-tags').includes("last-chance")) {
            itemDisclaimer.html("<span> This item is only eligible for exchange or store-credit</span>");
            itemDisclaimer.removeClass('hidden');
        }      
    });
}

$(function() {
    
    document.addEventListener('rebuy:smartcart.ready', function(event){
        const util = window.Rebuy.util;
        util.wait(addLastChanceDisclaimer, 300);
        
        //This event is triggered whenever SmartCart slider is opened or updated.
        document.addEventListener('rebuy:cart.change', function(event){
            // Update MiniCart when product is added via Rebuy SmartCart
            Shopify.miniCart.init();
            util.wait(addLastChanceDisclaimer, 300);
        });
    });

});
